import { View } from "react-big-calendar";

interface EventColor {
  textColor: string
  bgColor: string
}

class WOCalendar {
  private static instance: WOCalendar
  private minTime: Date
  private maxTime: Date
  private defaultView: View;
  private defaultDate: Date;
  private busyColor: EventColor;
  private availableColor: EventColor;

  protected constructor() {
    this.minTime = new Date()
    this.minTime.setHours(8, 0, 0)
    this.maxTime = new Date()
    this.maxTime.setHours(18, 0, 0)
    this.defaultView = "day";
    this.defaultDate = new Date();

    this.busyColor = {
      bgColor: "#F2F3F4",
      textColor: "#345EA6"
    }

    this.availableColor = {
      bgColor: "#DBEFFF",
      textColor: "#345EA6"
    }

  }

  public static getInstance(): WOCalendar {
    if (!WOCalendar.instance) WOCalendar.instance = new WOCalendar()

    return WOCalendar.instance
  }

  public getMinTime(): Date {
    return this.minTime
  }

  public getMaxTime(): Date {
    return this.maxTime
  }

  public getDefaultView(): View {
    return this.defaultView;
  }

  public getDefaultDate(): Date {
    return this.defaultDate;
  }

  public getRandomColor(): string {
    const letters = '0123456789ABCDEF'
    let color = '#'
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)]
    }
    return color
  }

  public calculateContrastColor(hexColor: string): string {
    const r = parseInt(hexColor.substring(1, 2), 16)
    const g = parseInt(hexColor.substring(3, 2), 16)
    const b = parseInt(hexColor.substring(5, 2), 16)

    const luminance = (r * 0.299 + g * 0.587 + b * 0.114) / 255

    return luminance > 0.5 ? '#000000' : '#ffffff'
  }

  public getBusyColor() {
    return this.busyColor;
  }
  public getAvailableColor() {
    return this.getAvailableColor;
  }
}

export default WOCalendar
